import { Box, Card, CardHeader, Divider, Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import UnreadMessagesList from './UnreadMessagesList/UnreadMessagesList';

const useStyles = makeStyles()((theme: Theme) => ({
    paperContainer: {
        height: '53vh',
        display: 'flex',
        flexDirection: 'column',
    },
    chartTitle: {
        padding: theme.spacing(2),
    },
    gridContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        width: '100%',
        alignItems: 'center',
    },
    timeline: {
        overflow: 'auto',
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
    },
}));

export default function UnreadMessages() {
    const { classes } = useStyles();

    return (
        <Card className={classes.paperContainer}>
            <CardHeader title="Unread Messages" />
            <Divider />
            <Box className={classes.timeline}>
                <UnreadMessagesList />
            </Box>
        </Card>
    );
}
